{
  "checkEmailMessage": "If {{email}} can be registered, we have sent it a link. Open it within 30 minutes to confirm the address.",
  "checkEmailTitle": "Check your email",
  "closed": "This installation creates accounts by invitation only. Ask an administrator for one.",
  "intro": "We send a link to your email address. Open it to confirm the address.",
  "noEmailDelivery": "This installation does not send email. Contact the operator to configure email delivery before verifying your account.",
  "resend": "Send the link again",
  "resent": "If the address waits for confirmation, a new link is on its way.",
  "submit": "Create account",
  "title": "Create an account"
}
